import { lazy } from "react";

const SupplyConsumption = lazy(() => import("../pages/user/ProductionConsumption/ElectricityUsage/supply/SupplyConsumption"));
const TimeUsege = lazy(() => import("../pages/user/ProductionConsumption/ElectricityUsage/timeUsege/TimeUsage"));
const DayUsage = lazy(() => import("../pages/user/ProductionConsumption/ElectricityUsage/dayUsege/DayUsage"));
const MonthUsage = lazy(() => import("../pages/user/ProductionConsumption/ElectricityUsage/monthUsege/MonthUsage"));
const InvalidPowrUsage = lazy(() => import("../pages/user/ProductionConsumption/ElectricityUsage/invalidPowrUsage/InvalidPowrUsage"));
const UsageLoad = lazy(() => import("../pages/user/ProductionConsumption/ElectricityUsage/usageLoad/UsageLoad"));
const UsageLoadDetail = lazy(() => import("../pages/user/ProductionConsumption/ElectricityUsage/usageLoad/UsageLoadDetail"));
const EmissionStatus = lazy(() => import("../pages/user/ProductionConsumption/gasEmissions/EmissionStatus"));
const FacilityEmissions = lazy(() => import("../pages/user/ProductionConsumption/gasEmissions/FacilityEmissions"));
const ScopeEmissions = lazy(() => import("../pages/user/ProductionConsumption/gasEmissions/ScopeEmissions"));
const SolarPower = lazy(() => import("../pages/user/ProductionConsumption/renewablePowerGeneration/SolarPower"));
const EssPower = lazy(() => import("../pages/user/ProductionConsumption/renewablePowerGeneration/EssPower"));
const LoadCapacity = lazy(() => import("../pages/user/ProductionConsumption/forecast/Load"));
const FareCheck = lazy(() => import("../pages/user/ProductionConsumption/electricCharges/FareCheck"));
const FacilityBoard = lazy(() => import("app/pages/user/ProductionConsumption/facility/status/FacilityBoard"));
const Board = lazy(() => import("app/pages/user/ProductionConsumption/facility/control/Board"));
const PricingPlan = lazy(() => import("../pages/user/ProductionConsumption/electricCharges/PricingPlan"));
const Power = lazy(() => import("../pages/user/ProductionConsumption/forecast/Power"));
const DemandPower = lazy(() => import("app/pages/user/ProductionConsumption/ElectricityUsage/demandPower/DemandPower"));
const DCGridSply = lazy(() => import("app/pages/user/ProductionConsumption/dcGridSupply/DcGridSplyBase"));


// 사용자
export const pcRouter: any = [
  //생산/소비 현황
  { path: "pc/facility/status/:tab?", element: <FacilityBoard /> }, // 센서 통신 현황
  { path: "pc/facility/control/:tab?", element: <Board /> }, // 센서 통신 현황

  //전기 사용량
  { path: "pc/eu/supplyconsumption", element: <SupplyConsumption /> },
  { path: "pc/eu/timeusege", element: <TimeUsege /> },
  { path: "pc/eu/dayusege", element: <DayUsage /> },
  { path: "pc/eu/monthusege", element: <MonthUsage /> },
  { path: "pc/eu/invalidpowrusage", element: <InvalidPowrUsage /> },
  { path: "pc/eu/usageload", element: <UsageLoad /> },
  { path: "pc/eu/usageload/detail", element: <UsageLoadDetail /> },
  { path: 'pc/eu/demandpower', element: <DemandPower />},
  { path: 'pc/eu/dcgridsply', element: <DCGridSply />},

  //온실가스 배출량
  { path: "pc/gas/dischargstatus", element: <EmissionStatus /> },
  { path: "pc/gas/facility", element: <FacilityEmissions /> },
  { path: "pc/gas/scope", element: <ScopeEmissions /> },

  //신재생 발전량
  { path: "pc/renewal/solar", element: <SolarPower /> },
  { path: "pc/renewal/ess", element: <EssPower /> },

  //발전량 예측
  { path: "pc/forecast/power", element: <Power /> },
  { path: "pc/forecast/load", element: <LoadCapacity /> },

  //전기 사용 요금
  { path: "pc/charges/fareCheck", element: <FareCheck /> },
  { path: "pc/charges/pricingplan", element: <PricingPlan /> },
];